<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    title="文件夹排序"
    okText="确认"
  >
    <div class="flex-b mt-10 mb-10">
      <div>子文件夹（{{ list.length }}）</div>
      <div class="cursor-p flex" @click="add">
        <component class="mr-6" :is="icons['PlusOutlined']" />新建文件夹
      </div>
    </div>
    <div class="scroll">
      <draggable v-model="list" class="list-group" item-key="id" handle=".handle">
        <template #item="{ element }">
          <div class="flex-b mb-10 item">
            <div class="flex-s flex-1">
              <img src="@/assets/images/aiDAM/sortIcon.png" class="wd14 handle" />
              <component class="ml-6 mr-6" :is="icons[element.icon || 'PlusOutlined']" />
              <div v-if="!element.isEdit">{{ element.name }}</div>
              <div v-else>
                <a-input
                  v-model:value="editInfo.name"
                  size="small"
                  class="wd80"
                  @blur="saveEdit(element)"
                  @click.stop
                />
              </div>
            </div>
            <div class="options">
              <div class="count">{{ element.fileNum }}</div>
              <div class="menu">
                <dropDownMenu :options="options" :data="element"> </dropDownMenu>
              </div>
            </div>
          </div>
        </template>
      </draggable>
    </div>
  </a-modal>
</template>

<script setup>
import { Modal as AModal, Input as AInput, message } from 'ant-design-vue'
import { ref, useAttrs, watch } from 'vue'
import * as icons from '@ant-design/icons-vue'
import { aigcStore } from '@/store/aigcStore'
import draggable from 'vuedraggable'
import dropDownMenu from '@/components/dropDownMenu.vue'
import { queryFolderList, editFolder, sortFolders } from '@/service/api/aiDam'
import eventsBus from '@/utils/eventsBus'
import { cloneDeep } from 'lodash'

const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const editInfo = ref(null)
const options = ref([
  {
    text: '重命名',
    fnClick: (res) => {
      res.isEdit = true
      editInfo.value = cloneDeep(res)
    }
  },

  {
    text: '删除文件夹',
    fnClick: (res) => {
      store.openDeleteFolderModal(res)
    },
    style: {
      color: 'red'
    }
  }
])
const list = ref([])

const add = () => {
  store.openNewFolderModal({
    parentId: store.sortFolderData.parentId,
    type: 'add',
    addChild: true,
    notPermissionList: true
  })
}
const saveEdit = () => {
  editFolder(
    {
      ...editInfo.value
    },
    editInfo.value.id
  ).then((res) => {
    if (res.data) {
      message.success('编辑成功')
      getList()
    }
  })
}
const handleOk = () => {
  confirmLoading.value = true
  list.value = list.value.map((i, index) => {
    return {
      ...i,
      sort: index
    }
  })
  sortFolders(
    {
      aigcFolderDTOList: list.value
    },
    store.sortFolderData.parentId
  ).then((res) => {
    if (res.data) {
      emits('asyncSuccess', list.value)
      eventsBus.emit('sortFolder', list.value)
    }
    confirmLoading.value = false
  })
}
const getList = () => {
  if (!store.sortFolderData?.parentId) return
  queryFolderList(
    {
      parentId: store.sortFolderData.parentId
    },
    store.sortFolderData.parentId
  ).then((res) => {
    if (res.data) {
      list.value = res.data
    }
  })
}
watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    list.value = []
    if (val) {
      getList()
    }
  }
)
eventsBus.on('newFolder', (res) => {
  if (!res) {
    getList()
  }
})
eventsBus.on('deleteFolder', (res) => {
  if (!res) {
    getList()
  }
})
</script>

<style lang="less" scoped>
.scroll {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}
.count {
  width: 40px;
  margin-left: 10px;
  display: block;
  text-align: right;
}
.menu {
  width: 60px;
  margin-left: 10px;
  display: none;
  text-align: right;
  cursor: pointer;
}

.item:hover {
  .count {
    display: none;
  }
  .menu {
    display: block;
  }
}
.handle {
  cursor: move;
}
</style>
